var _g, _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEarnings({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 45,
    viewBox: "0 0 40 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_di)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.9997 24.6555C25.339 24.6555 29.6673 20.3272 29.6673 14.9879C29.6673 9.6486 25.339 5.32025 19.9997 5.32025C14.6604 5.32025 10.332 9.6486 10.332 14.9879C10.332 20.3272 14.6604 24.6555 19.9997 24.6555Z",
    fill: "url(#paint0_linear)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.8788 20.2612C20.8788 20.7469 20.4857 21.14 19.9999 21.14C19.5141 21.14 19.121 20.7469 19.121 20.2612V19.2152C18.6407 19.0452 18.2098 18.7524 17.892 18.3291C17.6002 17.9412 17.6774 17.3902 18.0653 17.0984C18.4499 16.8083 19.0026 16.8821 19.2961 17.2717C19.7596 17.888 20.8788 17.5086 20.8788 16.7456C20.8788 16.2607 20.484 15.8668 19.9999 15.8668C18.546 15.8668 17.3633 14.684 17.3633 13.2301C17.3633 12.0858 18.1002 11.1194 19.121 10.7554V9.71463C19.121 9.22885 19.5141 8.83575 19.9999 8.83575C20.4857 8.83575 20.8788 9.22885 20.8788 9.71463V10.7606C21.3591 10.9306 21.79 11.2234 22.1079 11.6466C22.3997 12.0346 22.3224 12.5856 21.9345 12.8774C21.55 13.1675 20.999 13.0929 20.7037 12.704C20.5355 12.48 20.278 12.3513 19.9999 12.3513C19.5158 12.3513 19.121 12.7452 19.121 13.2301C19.121 13.715 19.5158 14.109 19.9999 14.109C21.4538 14.109 22.6365 15.2918 22.6365 16.7456C22.6365 17.8899 21.8996 18.8564 20.8788 19.2204V20.2612Z",
    fill: "url(#paint1_linear)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6188 5.60752C15.201 1.02371 22.3429 0.538396 27.4813 4.12861C27.0842 4.09082 26.6966 4.31294 26.5639 4.70808C26.4111 5.16896 26.66 5.66676 27.12 5.82039L30.8501 7.0623C31.1508 7.16443 31.5032 7.09535 31.7496 6.85032C31.9848 6.61513 32.0672 6.26668 31.9625 5.95081L30.7197 2.22162C30.5652 1.76074 30.0657 1.51524 29.6074 1.66629C29.1473 1.81904 28.8984 2.31689 29.0512 2.77777L29.1955 3.20983C23.3358 -1.42273 14.7842 -1.04352 9.37597 4.36473C5.42103 8.31968 4.01348 14.1002 5.70256 19.4498C5.85015 19.9172 6.34584 20.1679 6.80461 20.024C7.26807 19.8773 7.52383 19.3837 7.37793 18.9212C5.88794 14.198 7.12898 9.09731 10.6188 5.60752ZM34.2974 10.5259C34.1515 10.0633 33.6606 9.81096 33.1954 9.9517C32.7319 10.0985 32.4761 10.592 32.622 11.0546C34.112 15.7777 32.8709 20.8784 29.3811 24.3682C24.7989 28.952 17.6572 29.4373 12.5188 25.8471C12.9166 25.8851 13.3034 25.6637 13.4361 25.2677C13.5888 24.8068 13.3399 24.309 12.8799 24.1553L9.14987 22.9134C8.834 22.807 8.48725 22.892 8.25037 23.1254C8.01518 23.3606 7.9328 23.709 8.0375 24.0249L9.28029 27.7541C9.4338 28.2114 9.92914 28.4639 10.3926 28.3094C10.8527 28.1567 11.1016 27.6588 10.9488 27.198L10.8044 26.7659C13.508 28.9032 16.781 29.9805 20.0585 29.9805C23.8847 29.9805 27.7109 28.524 30.6239 25.611C34.5789 21.6561 35.9865 15.8756 34.2974 10.5259Z",
    fill: "url(#paint2_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_di",
    x: 0.332031,
    y: 5.32025,
    width: 39.3353,
    height: 39.3353,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.305882 0 0 0 0 0.67451 0 0 0 0 0.976471 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.279167 0 0 0 0 0.655653 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 8.87734,
    y1: -14.4017,
    x2: 33.9316,
    y2: -13.1102,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#93CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2894FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 20,
    y1: 29.9805,
    x2: 20,
    y2: -0.00000318803,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 20,
    y1: 29.9805,
    x2: 20,
    y2: -0.00000357396,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6FBCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2894FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEarnings);
export default __webpack_public_path__ + "static/media/earnings.7e7ac5d488eacb2b651b36131a37a34d.svg";
export { ForwardRef as ReactComponent };